/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiEntityGroupRecalculationFilter
 */
export interface InternalApiEntityGroupRecalculationFilter {
    /**
     * 
     * @type {Date}
     * @memberof InternalApiEntityGroupRecalculationFilter
     */
    startTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiEntityGroupRecalculationFilter
     */
    endTime?: Date;
}

/**
 * Check if a given object implements the InternalApiEntityGroupRecalculationFilter interface.
 */
export function instanceOfInternalApiEntityGroupRecalculationFilter(value: object): value is InternalApiEntityGroupRecalculationFilter {
    return true;
}

export function InternalApiEntityGroupRecalculationFilterFromJSON(json: any): InternalApiEntityGroupRecalculationFilter {
    return InternalApiEntityGroupRecalculationFilterFromJSONTyped(json, false);
}

export function InternalApiEntityGroupRecalculationFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiEntityGroupRecalculationFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'startTime': json['startTime'] == null ? undefined : (new Date(json['startTime'])),
        'endTime': json['endTime'] == null ? undefined : (new Date(json['endTime'])),
    };
}

export function InternalApiEntityGroupRecalculationFilterToJSON(json: any): InternalApiEntityGroupRecalculationFilter {
    return InternalApiEntityGroupRecalculationFilterToJSONTyped(json, false);
}

export function InternalApiEntityGroupRecalculationFilterToJSONTyped(value?: InternalApiEntityGroupRecalculationFilter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'startTime': value['startTime'] == null ? value['startTime'] : value['startTime'].toISOString(),
        'endTime': value['endTime'] == null ? value['endTime'] : value['endTime'].toISOString(),
    };
}

